import appsettingsReducer from './appsettings-reducer';

export default appsettingsReducer;
